// ===============================================================
// Forms — Module Layout with sub-navigation
// ===============================================================

import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Group, Button } from '@mantine/core';
import {
  IconLayoutDashboard, IconTemplate, IconTools, IconClipboardList, IconWorld,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/forms', icon: IconLayoutDashboard, exact: true },
  { label: 'Published', path: '/forms/published', icon: IconWorld },
  { label: 'Templates', path: '/forms/templates', icon: IconTemplate, minLevel: 'editor' },
  { label: 'Builder', path: '/forms/builder', icon: IconTools, minLevel: 'editor' },
  { label: 'Responses', path: '/forms/responses', icon: IconClipboardList },
];

export default function FormsLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('forms' as any, NAV_ITEMS);

  const isDetail = pathname.match(/\/forms\/builder\/.+/);

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <>
        <Breadcrumbs
          items={[
            { label: 'Hub', to: '/' },
            { label: 'Forms', to: '/forms' },
            ...(currentPage && currentPage.path !== '/forms' ? [{ label: currentPage.label }] : []),
          ]}
        />
        <Group gap="xs" mb="md" style={{ borderBottom: '1px solid var(--frost)', paddingBottom: 12 }}>
          {visibleItems.map(item => {
            const active = item.exact ? pathname === item.path : pathname.startsWith(item.path);
            return (
              <Button
                key={item.path}
                variant={active ? 'filled' : 'light'}
                color={active ? brand.blurple : 'gray'}
                size="xs"
                leftSection={<item.icon size={14} />}
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </Button>
            );
          })}
        </Group>
        </>
      )}
      <Outlet />
    </div>
  );
}
